import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { initYandexMetrika } from "./metrika";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// Регистрируем сервис-воркер для поддержки PWA
serviceWorkerRegistration.register();

// Яндекс.Метрика (включается только при заданном REACT_APP_YANDEX_METRIKA_ID)
initYandexMetrika();
